import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from './redux/actions';
import { Form, Input, message, Button } from "antd";
import { cookies, common } from '../../utils';
import { ssoUrl } from "../../common/baseConfig";
import $ from "jquery";
export class LoginByPhone extends Component {
  timer = null;
  state = {
    phone: "",
    codeTxt: "获取验证码"
  }
  static propTypes = {
    common: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };
  handlePhoneSubmit = e => {
    e.preventDefault();
    this.props.form.validateFields((err, values) => {
      values.IsShowPhone = 0;
      values.LoginType = 2;
      clearInterval(this.timer);
      if (!err) {
        this.props.actions.fetchLoginByPhone(values).then(res => {
          if (res.SuccessResponse) {
            const { StuID, Name, Phone, System_Station_ID } = res.Data
            this.props.actions.fetchStudentBasics({ StuID })
            message.success(res.Message);
            cookies.setCookie('UserKey', StuID);
            cookies.setCookie('UserNameKey', Name);
            cookies.setCookie('UserPhoneKey', Phone);
            localStorage.setItem('showLoginModal', false);
            localStorage.setItem('studentinfo', JSON.stringify(res.Data));
            //记录登录状态
            let params = {
              'SignInType': 2,
              'Account': values.Phone,
              'Password': values.PhoneCode,
              'SignInSource': 1,
              'System_Station_ID': System_Station_ID,
            }
            $.ajax({
              type: "POST",
              url: ssoUrl + "/sso/ssostudent/signin",
              data: params,
              xhrFields: { withCredentials: true },
              crossDomain: true,
            });
            //跳转登录
            if (this.props.isNotJump) {
              window.location.reload();
            } else {
              // this.props.actions.fetchCreatePromoter({ PromotersCode: localStorage.getItem('PromotersCode')}).then(res => {
              //   if(res.SuccessResponse){
              //     this.props.history.push('/center');
              //   }else{
              //     message.error(res.Message);
              //   }
              // })
              this.props.history.push('/center');
            }
          }
        })
      }
    })
  }
  getCode() {
    if (this.state.phone.trim() === "") {
      message.warn("手机号码不能为空");
      return;
    }
    if (common.checkPhone(this.state.phone)) {
      let seconds = 60;
      this.setState({
        codeTxt: "发送中..."
      })
      this.props.actions.fetchGetPhoneCodeByLogin({ Phone: this.state.phone }).then(res => {
        if (res.SuccessResponse) {
          message.success(res.Message);
          this.timer = setInterval(() => {
            if (seconds > 0) {
              this.setState({
                codeTxt: `${seconds--}秒`
              })
            } else {
              clearInterval(this.timer);
              this.setState({
                codeTxt: "获取验证码",
              })
            }
          }, 1000)
        } else {
          this.setState({
            codeTxt: "获取验证码",
          })
        }
      })
    } else {
      message.warn("请输入正确的手机号")
    }
  }
  render() {
    const { getFieldDecorator } = this.props.form;
    const { codeTxt } = this.state;
    return (
      <div className="common-login-by-phone">
        <Form onSubmit={this.handlePhoneSubmit} className="login-form">
          <Form.Item>
            {getFieldDecorator('Phone', {
              rules: [{ required: true, message: '请输入手机号' }, {
                pattern: "^[1][3,4,5,6,7,8,9][0-9]{9}$", message: "请输入正确的手机号"
              }],
            })(
              <Input
                placeholder="手机号"
                onChange={e => this.setState({
                  phone: e.target.value
                })}
                style={{ height: 40 }}
              />,
            )}
          </Form.Item>
          <Form.Item>
            {getFieldDecorator('PhoneCode', {
              rules: [{ required: true, message: '请输入验证码' }],
            })(
              <Input
                placeholder="验证码"
                style={{ height: 40 }}
                suffix={
                  <p className="getCode" onClick={() => {
                    if (codeTxt === "获取验证码") {
                      this.getCode();
                    }
                  }}>{codeTxt}</p>
                }
              />,
            )}
          </Form.Item>
          <Form.Item>
            <Button type="theme" htmlType="submit" className="login-form-button">
              登录
              </Button>
          </Form.Item>
        </Form>
      </div>
    );
  }
}

/* istanbul ignore next */
function mapStateToProps(state) {
  return {
    common: state.common,
  };
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch)
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Form.create({ name: 'normal_login_by_phone' })(LoginByPhone));



// WEBPACK FOOTER //
// ./src/features/common/LoginByPhone.js